// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".site-search-close{display:inline-flex;align-items:center;cursor:pointer;width:auto;padding:0;border:none;background:transparent;color:inherit;font:inherit;line-height:normal}.site-search-close_text{margin-left:16px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
